import styled from 'styled-components';
import { Card } from 'react-bootstrap';

export const AccordionCardBody = styled(Card.Body)`
  padding: 5px 0 0 !important;
  font-size: inherit !important;
`;
